export const ADD_PRODUCT = 'add_product';

export function addProductAction(product) {
  return {
    type: ADD_PRODUCT,
    product: product
  }
}
